import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const integrations = [
   { name: 'apple', opacity: 0.2 },
   { name: 'brevo', opacity: 0.4 },
   { name: 'ga', opacity: 0.6 },
   { name: 'github', opacity: 0.8 },
   { name: 'shopify', opacity: 1.0 },
   { name: 'stripe', opacity: 0.8 },
   { name: 'youtube', opacity: 0.6 },
   { name: 'notion', opacity: 0.4 }
]

const IntegrationsFeature = ({ active }) => {
   const [visible, setVisible] = useState(false)

   useEffect(() => {
      if (active) {
         setTimeout(() => {
            setVisible(true)
         }, 200)
      } else {
         setVisible(false)
      }
   }, [active])

   return (
      <div className="relative w-full h-full">
         <div
            className={classNames(
               'absolute w-[170%] sm:w-[150%] flex gap-3 top-1/2 left-1/2 -translate-y-1/2 transition-all duration-700',
               visible ? '-translate-x-1/2 opacity-100' : 'translate-x-0 opacity-0'
            )}>
            {integrations.map(integration => (
               <div
                  key={integration.name}
                  className="w-[15%] aspect-square flex justify-center items-center bg-white p-4 rounded-xl shadow-lg"
                  style={{ opacity: integration.opacity }}>
                  <img
                     className="w-full"
                     src={`/assets/custom/communities/images/features/integrations/${integration.name}.png`}
                     alt={integration.name}
                  />
               </div>
            ))}
         </div>
      </div>
   )
}

IntegrationsFeature.propTypes = {
   active: PropTypes.bool.isRequired
}

export default IntegrationsFeature
